module.exports = __webpack_public_path__ + "static/media/history-enabled.a1fae2f1.svg";